/** Inline text attachments for coach / mentor chats (.txt, .md, .csv). */
export const CHAT_TEXT_ATTACHMENT_MAX_BYTES = 256 * 1024;

export type TextAttachmentResult =
  | { ok: true; body: string }
  | { ok: false; code: "size" | "type" };

export async function readChatTextAttachment(file: File): Promise<TextAttachmentResult> {
  if (file.size > CHAT_TEXT_ATTACHMENT_MAX_BYTES) {
    return { ok: false, code: "size" };
  }
  if (!(file.type.startsWith("text/") || /\.(txt|md|csv)$/i.test(file.name))) {
    return { ok: false, code: "type" };
  }
  const text = await file.text();
  const body = `[Attached: ${file.name}]\n${text.slice(0, 12_000)}`;
  return { ok: true, body };
}
